module.exports = __webpack_public_path__ + "lower-payments-235336db5f201a990fca977e4ab27438.svg";


//////////////////
// WEBPACK FOOTER
// ../images/lower-payments.svg
// module id = 1254
// module chunks = 4 5